const ACCOUNT_EXISTS_CODES = new Set([
  'UsernameExistsException',
  'AliasExistsException',
]);

export function mapCognitoAuthError(err) {
  if (!err) return 'Something went wrong. Please try again.';

  const code = err.code || err.name || '';
  const message = err.message || '';

  if (ACCOUNT_EXISTS_CODES.has(code)
    || message.includes('UsernameExistsException')
    || message.includes('AliasExistsException')) {
    return 'An account with this email already exists. Please sign in instead.';
  }

  return message || 'Something went wrong. Please try again.';
}

export function isAccountExistsError(err) {
  const code = err?.code || err?.name || '';
  const message = err?.message || '';
  return ACCOUNT_EXISTS_CODES.has(code)
    || message.includes('UsernameExistsException')
    || message.includes('AliasExistsException')
    || message.includes('already exists');
}
